import * as React from 'react';

import { Box } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonVariants, ActionLink } from 'components/action-button';
import { ModalHeading } from 'components/modal';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { routes } from 'utils/routing';

import { Container, ContainerThirdParties, LoadingText } from './delivery-unavailable.styled';
import { IDeliveryUnavailableProps } from './types';

/**
 *
 * DeliveryUnavailable informs the guest that the address they entered
 * is unable to receive delivery at this time
 *
 */

const DeliveryUnavailable: React.FC<IDeliveryUnavailableProps> = ({ address, close }) => {
  const { formatMessage } = useIntl();
  const enableThirdPartyRedirect = useFlag(
    LaunchDarklyFlag.ENABLE_THIRD_PARTY_REDIRECT_UNAVAILABLE_DELIVERY_MODAL
  );
  const lieferandoLink: string = useFlag(LaunchDarklyFlag.LIEFERANDO_BUTTON_URL);
  const uberEatsLink: string = useFlag(LaunchDarklyFlag.UBEREATS_BUTTON_URL);

  const onClickExternalButton = (e: React.SyntheticEvent, url: string) => {
    e.preventDefault();
    window.open(url, '_blank', 'noopener');
    close();
  };
  return (
    <Container data-testid="delivery-unavailable-for-address">
      <ModalHeading>{formatMessage({ id: 'deliveryNotAvailable' })}</ModalHeading>
      <LoadingText>
        {formatMessage({ id: 'cannotDeliveryTo' })}
        <br />
        {address}
      </LoadingText>
      <Box width="100%" minWidth="auto" minHeight="3rem" margin="8px 0" center>
        <ActionLink fullWidth to={routes.storeLocator}>
          {formatMessage({ id: 'orderPickup' })}
        </ActionLink>
      </Box>
      <Box width="100%" minWidth="auto" minHeight="3rem" margin="8px 0" center>
        <ActionButton
          fullWidth
          data-testid="use-different-address"
          onClick={close}
          variant={ActionButtonVariants.OUTLINE}
        >
          {formatMessage({ id: 'useDifferentAddress' })}
        </ActionButton>
      </Box>
      {enableThirdPartyRedirect && (
        <ContainerThirdParties>
          <p>{formatMessage({ id: 'visitMarketplaces' })}</p>
          <Box width="100%" minWidth="auto" margin="8px 0" center>
            <ActionLink
              fullWidth
              to={routes.storeLocator}
              onClick={e => onClickExternalButton(e, lieferandoLink)}
            >
              {formatMessage({ id: 'lieferando' })}
            </ActionLink>
          </Box>
          <Box width="100%" minWidth="auto" margin="8px 0" center>
            <ActionLink
              fullWidth
              to={routes.storeLocator}
              onClick={e => onClickExternalButton(e, uberEatsLink)}
            >
              {formatMessage({ id: 'ubereats' })}
            </ActionLink>
          </Box>
        </ContainerThirdParties>
      )}
    </Container>
  );
};

export default DeliveryUnavailable;
